<template>
  <div style="width: 800px;margin: 0 auto;position: relative">
    <!--    <div-->
    <!--      class="bin-panel"-->
    <!--      :key="index" v-for="(item,index) in bin" :style="{top:`${index*40}px`,zIndex:999-index}">-->
    <!--      <div class="title">Layer {{ `${index + 1}` }}</div>-->
    <!--      <table class="bin-wrap" :style="{}">-->
    <!--        <tr :key="`${index}-${trIndex}`" v-for="(trItem,trIndex) in item">-->
    <!--          <td-->
    <!--            v-for="(tdItem,tdIndex) in trItem"-->
    <!--            :style="{backgroundColor:tdItem.color}"-->
    <!--            :key="`${index}-${trIndex}-${tdIndex}`"-->
    <!--          >&nbsp;-->
    <!--          </td>-->
    <!--        </tr>-->
    <!--      </table>-->
    <!--    </div>-->

    <div style="width:800px;height: 600px">
      <simple-chart :option="option"/>
    </div>
  </div>
</template>

<script>
import SimpleChart from '@/components/SimpleChart.vue';
import chinaJsonGEO from '@/assets/china.json';
import worldJsonGEO from '@/assets/world.json';
import * as echarts from 'echarts';

echarts.registerMap('CHINA', chinaJsonGEO);
echarts.registerMap('WORLD', worldJsonGEO);

const color = ['#ada9a9', '#5f933b', '#6ba543', '#ffc000', '#ff0000', '#c00000'];

export default {
  name: 'Test',
  components: { SimpleChart },
  // components: { SizeGenerator },
  data() {
    return {
      bin: [],
      option: {
        series: [
          {
            type: 'map',
            mapType: 'CHINA', // 自定义扩展图表类型
            itemStyle: {
              areaColor: {
                image: point, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: 'repeat', // 是否平铺，可以是 'repeat-x', 'repeat-y', 'no-repeat'
              },
              borderWidth: 0,
            },
            data: [],
            // 自定义名称映射
            nameMap: {},
          },
        ],
      },
    };
  },
  created() {
    const z = 14;
    const y = 20;
    const x = 100;
    const data = [];
    for (let i = 0; i < z; i += 1) {
      const yData = [];
      for (let j = 0; j < y; j += 1) {
        const zData = [];
        for (let k = 0; k < x; k += 1) {
          const number = Math.ceil(Math.random() * 6) - 1;
          zData.push({
            status: 'FILL',
            color: color[number],
            key: `${i}-${j}-${k}`,
          });
        }
        yData.push(zData);
      }
      data.push(yData);
    }
    this.bin = data;
  },
};
</script>

<style scoped>
.bin-panel {
  margin: 0 auto;
  position: absolute;
}

.bin-wrap {
  transform-style: preserve-3d;
  transform: rotatey(-5deg) rotatex(-80deg) rotatez(-15deg);;
  margin: 0 auto;
  width: 100%;
  background: #ffffff;
  border: 5px solid #909090;
}

.bin-panel .title {
  position: absolute;
  left: -134px;
  top: 214px;
}

.bin-wrap td {
  background: #eeeeee91;
  user-select: none;
  margin: 5px;
  border: 2px solid #ffffff;
}
</style>
